export const ADMIN_PATHS = {
  root: 'admin',
  users: 'users',
  userDetail: 'users/:id'
};
